// extracted by mini-css-extract-plugin
export default {"label":"styles__label___jSukY","account":"styles__account___RBZDM","body":"styles__body___4m0Js","title":"styles__title___cUrek","subTitle":"styles__subTitle___dOCbS"};